'use strict';

var createMiddleware = require('./create-middleware');
var createMetaReducer = require('./create-meta-reducer');
// Extensions
var logger = require('./extensions/logger');
var offlineWeb = require('./extensions/offline-web');
var offlineReactNative = require('./extensions/offline-react-native');
// Event Helpers
var createGAevent = require('./event-helpers/create-ga-event');
var createGApageview = require('./event-helpers/create-ga-pageview');
var createGAuserTiming = require('./event-helpers/create-ga-user-timing');

module.exports = {
  createMiddleware: createMiddleware,
  createMetaReducer: createMetaReducer,
  Extensions: {
    logger: logger,
    offlineWeb: offlineWeb,
    offlineReactNative: offlineReactNative
  },
  EventHelpers: {
    createGAevent: createGAevent,
    createGApageview: createGApageview,
    createGAuserTiming: createGAuserTiming
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/index.js
// module id = 329
// module chunks = 0